import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * واجهة إعدادات Firebase
 */
export interface FirebaseSettings {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

// الإعدادات الافتراضية
const DEFAULT_FIREBASE_SETTINGS: FirebaseSettings = {
  apiKey: "AIzaSyBQbFgcMiMWKRxTq9g9YyWOh2x-am9UJh4",
  authDomain: "maintenance-system-bab4f.firebaseapp.com",
  projectId: "maintenance-system-bab4f",
  storageBucket: "maintenance-system-bab4f.appspot.com",
  messagingSenderId: "724247695519",
  appId: "1:724247695519:web:3509e138a2f276959712aa"
};

/**
 * الحصول على إعدادات Firebase
 * @returns وعد بإعدادات Firebase
 */
export const getFirebaseSettings = async (): Promise<FirebaseSettings> => {
  try {
    // محاولة الحصول على الإعدادات من Firestore
    const settingsDoc = await getDoc(doc(db, 'settings', 'firebase'));
    
    if (settingsDoc.exists()) {
      const data = settingsDoc.data() as FirebaseSettings;
      return {
        apiKey: data.apiKey || DEFAULT_FIREBASE_SETTINGS.apiKey,
        authDomain: data.authDomain || DEFAULT_FIREBASE_SETTINGS.authDomain,
        projectId: data.projectId || DEFAULT_FIREBASE_SETTINGS.projectId,
        storageBucket: data.storageBucket || DEFAULT_FIREBASE_SETTINGS.storageBucket,
        messagingSenderId: data.messagingSenderId || DEFAULT_FIREBASE_SETTINGS.messagingSenderId,
        appId: data.appId || DEFAULT_FIREBASE_SETTINGS.appId
      };
    }
    
    // إذا لم تكن الإعدادات موجودة، استخدم الإعدادات الافتراضية
    return DEFAULT_FIREBASE_SETTINGS;
  } catch (error) {
    console.error('Error getting Firebase settings:', error);
    return DEFAULT_FIREBASE_SETTINGS;
  }
};

/**
 * حفظ إعدادات Firebase
 * @param settings إعدادات Firebase
 * @returns وعد بنتيجة عملية الحفظ
 */
export const saveFirebaseSettings = async (settings: FirebaseSettings): Promise<void> => {
  try {
    await setDoc(doc(db, 'settings', 'firebase'), {
      ...settings,
      updatedAt: new Date()
    });
    
    console.log('Firebase settings saved successfully');
    
    // تنبيه المستخدم بضرورة إعادة تشغيل التطبيق
    alert('تم حفظ إعدادات Firebase بنجاح. يرجى إعادة تشغيل التطبيق لتطبيق التغييرات.');
  } catch (error) {
    console.error('Error saving Firebase settings:', error);
    throw error;
  }
};

export default {
  getFirebaseSettings,
  saveFirebaseSettings,
  DEFAULT_FIREBASE_SETTINGS
};
